import { render, staticRenderFns } from "./logs.vue?vue&type=template&id=0ffd4030&scoped=true"
import script from "./logs.vue?vue&type=script&lang=js"
export * from "./logs.vue?vue&type=script&lang=js"
import style0 from "./logs.vue?vue&type=style&index=0&id=0ffd4030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffd4030",
  null
  
)

export default component.exports